import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import StatusIcon from './icon/icon';
import {success} from '../../../assets/symbols/symbols/Symbols.css';
import loader from '../../../assets/animations/circleLoader.json';
import Animation from '../../../component/animation/Animation';
import {useEffect, useRef, useState} from 'react';
import CopyLink from '../../../component/copyLink/CopyLink';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

interface StatusRowProps {
    text: string;
    index: number;
    currentLoader: number;
} 
const StatusRow = ({text, index, currentLoader}:StatusRowProps) => (
    <css.infoRow>
        <css.infoValue>{text}</css.infoValue>
        {currentLoader === index ? 
            <css.circleLoader><Animation animation={loader} /></css.circleLoader>
            : currentLoader > index && <css.successIcon $icon={success} />
        }
    </css.infoRow>
); 

interface WillComPaymentProps {
    orderData: OrderData;
    onFinishClicked: () => void;
    loading: boolean;
} 
function WillComPayment({orderData, onFinishClicked, loading}: WillComPaymentProps){
    const [currentLoader, setCurrentLoader] = useState(1);
    const interval=useRef<NodeJS.Timeout | null>(null);
    const {t} = useTranslation('suspendedConfirmation');
    
    // Manages a 3-step loading animation sequence:
    // 1. Automatically advances through steps 1-3 every second
    // 2. Stays on step 3 while loading=true
    // 3. Moves to step 4 (complete) when loading=false
    // Cleans up interval on dismount and completion
    useEffect(() => {
        interval.current = setInterval(() => {
            setCurrentLoader((prev) => {
                if(prev < 3) {
                    return prev + 1;
                } else {
                    if(!loading) {
                        clearInterval(interval.current);
                        return 4;
                    }
                    return 3;
                }
            });
        }, 1000);
        return () => {
            if(interval.current) clearInterval(interval.current);
        };
    },[]);
    useEffect(()=>{
        if(!loading && currentLoader ===3){
            setCurrentLoader(4);
            clearInterval(interval.current);
        }
    }, [loading, currentLoader]);
        
    return (
        <Card mainTitle={' '} subTitle={orderData.eventTitle} {...orderData} >
            <css.confirmationBox>
                <StatusIcon icon={success} color={'#13D361'} />
                <StatusRow 
                    text={t('confirmingArrival')} 
                    index={1} 
                    currentLoader={currentLoader} 
                />
                <StatusRow 
                    text={t('chargingCard')} 
                    index={2} 
                    currentLoader={currentLoader} 
                />
                <StatusRow 
                    text={t('sendingTicket')} 
                    index={3} 
                    currentLoader={currentLoader} 
                />
                {currentLoader > 3 && (
                    <>
                        <css.successMessage>
                            {t('successMessage')}
                        </css.successMessage>
                        <css.ticketLink>
                            <CopyLink 
                                text={orderData.ticketUrl} 
                                title={t('ticketDownload')} 
                            />
                        </css.ticketLink>
                    </>
                )}
            </css.confirmationBox>

            <css.buttonRow>
                <Btn 
                    disabled={currentLoader <= 3} 
                    onClick={onFinishClicked}
                >
                    {t('finish')}
                </Btn>
            </css.buttonRow>
        </Card>
    );
}

export default WillComPayment;